import React from 'react';
import { useTranslation } from 'react-i18next';

import { FooterMenu } from '../../../../Components/FooterMenu';
import Header from '../../../../Components/Header';
import { UserAccessLink } from '../../../../Components/Admin/Users/UserAccessLink';

export const AgentUserAccessLink =  () => {
  const { t } = useTranslation();

  return (
    <div className='agent_layout'>
      <Header name={t('userAction.accessLink')} agentMenu={true} />
      <UserAccessLink />
      <FooterMenu/>
    </div>
  );
};
